import Layout from 'components/Layout';
import RcPagination from 'rc-pagination';
import React, { useCallback, useRef, useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  FormGroup,
  Input,
  Table,
} from 'reactstrap';


import Loader from '../components/Loader';
import ServiceModel from '../components/uuCafeService/ServiceModel';
import {
  deleteCafeServiceDetail,
  getCafeServiceList,
} from '../redux/actions/data/uuCafeServicesAction';
import style from '../styles/layout.module.css';
import MessageUtil from '../utils/MessageUtil';

const CafeServices = () => {
  const dispatch = useDispatch();
  const { loading, serviceList } = useSelector(state => state.cafeServiceList);

  const [keyword, setKeyword] = useState('');
  const [page, setPage] = useState(1);
  const [openModal, setOpenModel] = useState(false);
  const service = useRef({
    name: '',
    name_en: '',
  });

  const handlePageChange = useCallback(
    (value, keyword) => {
      dispatch(
        getCafeServiceList({
          keyword,
          page: value,
          page_size: serviceList.page_size || 10,
          type: 0,
        }),
      );
      setPage(value);
    },
    [dispatch, setPage, serviceList],
  );

  const handleDeleteItem = useCallback(
    async service => {
      try {
        await deleteCafeServiceDetail({
          id: service.id,
        });
        handlePageChange(1, keyword);
        MessageUtil.toastSuccess('刪除成功!');
      } catch (e) {
        MessageUtil.alertWanring('刪除失敗!', e);
      }
    },
    [handlePageChange, keyword],
  );

  useEffect(() => {
    handlePageChange(1, keyword);
  }, []);

  return (
    <Layout
      pageTitle="門市查詢-服務項目設定"
      items={[
        { isActive: true, page_name: 'UUCafe' },
        { isActive: true, page_name: '門市查詢-服務項目設定' },
      ]}
    >
      <ServiceModel
        openModal={openModal}
        setOpenModel={(show, isReload) => {
          if (isReload) {
            handlePageChange(1);
          }
          setOpenModel(show);
        }}
        service={service.current}
      />
      <Card className={style.search_card} style={{ overflow: 'hidden' }}>
        <CardHeader
          className={style.card_header}
          style={{ background: 'white' }}
        >
          搜尋條件
        </CardHeader>
        <CardBody>
          <FormGroup className="d-flex align-items-center">
            <label className="mx-3">服務項目:</label>
            <Input
              style={{ maxWidth: '200px' }}
              placeholder="輸入關鍵字"
              value={keyword}
              onChange={e => {
                setKeyword(e.target.value);
              }}
            />
          </FormGroup>
        </CardBody>
        <CardFooter className="text-end border-0">
          <Button
            type="button"
            className={style.modal_button_cancel}
            onClick={() => {
              setKeyword('');
            }}
          >
            <span className="btn-wrapper--label">取消</span>
          </Button>
          <Button
            type="button"
            color="primary"
            onClick={() => {
              handlePageChange(1, keyword);
            }}
          >
            <span className="btn-wrapper--label">搜尋</span>
          </Button>
        </CardFooter>
      </Card>
      <Card className={`${style.search_card} ${style['seo-card-layout']}`}>
        {!loading ? (
          <>
            <div className="d-flex align-items-center justify-content-between mb-3">
              <Button
                color="success"
                onClick={() => {
                  service.current = {
                    name: '',
                    name_en: '',
                  };
                  setOpenModel(true);
                }}
              >
                新增
              </Button>
            </div>
            <p className="small text-end mb-0">
              共 {serviceList.total_count} 筆
            </p>
            <div
              className={style.table_overflow}
              style={{ minHeight: '200px' }}
            >
              <Table hover bordered striped>
                <thead className={`thead-dark ${style.table_head}`}>
                  <tr>
                    <th nowrap="nowrap">門市查詢-服務項目設定</th>
                    <th style={{ minWidth: '120px' }}>異動日期</th>
                    <th>功能</th>
                  </tr>
                </thead>
                <tbody>
                  {serviceList.datas.map((data, index) => (
                    <tr key={index}>
                      <td>{data.name}</td>
                      <td>
                        <div className="text-nowrap">{data.updateDateTime}</div>
                        <div>{data.updater}</div>
                      </td>
                      <td nowrap="nowrap" className="text-center">
                        <Button
                          className="m-1"
                          size="sm"
                          outline
                          color="primary"
                          onClick={() => {
                            service.current = data;
                            setOpenModel(true);
                          }}
                        >
                          編輯
                        </Button>
                        <Button
                          className="m-1"
                          size="sm"
                          outline
                          color="danger"
                          onClick={() => {
                            MessageUtil.submitConfirm({
                              doneFun: () => {
                                handleDeleteItem(data);
                              },
                              title: '確認是否刪除',
                            });
                          }}
                        >
                          刪除
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <div className="d-flex align-items-center justify-content-center">
              <RcPagination
                current={page}
                pageSize={serviceList.page_size || 10}
                total={serviceList.total_count || 1}
                onChange={value => {
                  handlePageChange(value, keyword);
                }}
              />
            </div>
          </>
        ) : (
          <Loader />
        )}
      </Card>
    </Layout>
  );
};

export default CafeServices;
